<div id="multiPointsModal" class="modal fade" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <span>Select an element</span>
                <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="dismissModal.emit(end)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ng-container *ngFor="let e of elements | keyvalue" class="d-flex flex-column justify-content-center align-items-center">
                    <div class="element-block mb-3">
                        <h3 class="mb-0">{{multiPointsTypes[e.key]}}</h3>
                        <ng-container *ngFor="let v of e.value">
                            <button mat-stroked-button (click)="selectElement.emit({element: v, end: end})" class="w-100 my-2">
                                {{v.points[v.code]}}
                            </button>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>